module.exports = __webpack_public_path__ + "static/media/homeicon.d28aee41.svg";